let navigateFnCache = null;

export const setNavigator = (navigateFn) => {
    navigateFnCache = navigateFn;
};

export const goToLogin = () => {
    try {
        if (!navigateFnCache) {
            console.warn("Navigator not ready yet");
            return;
        }

        const params = new URLSearchParams(window.location.search);
        params.delete("action");

        const search = params.toString() ? `?${params.toString()}` : "";
        console.log("goToLogin --> navigating to login")
        navigateFnCache({
            pathname: "/login",
            search,
            hash: window.location.hash
        });
    } catch (error) {
        console.error("Error navigating to login:", error);
        console.log("goToLogin -->catch-> navigating to login")
        window.location.href = '/login';
    }
};
